/**
 * Base URL for Netlify Functions from the browser.
 * Matches CatalogChatWidget: optional REACT_APP_NETLIFY_FUNCTIONS_BASE, else same origin.
 */
export function netlifyFunctionsBase(): string {
  const env = process.env.REACT_APP_NETLIFY_FUNCTIONS_BASE;
  if (env) return env.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/.netlify/functions`;
  }
  return '/.netlify/functions';
}
